<template lang="pug">
  .payment-settings
    v-container(style="max-width:600px")
      div.d-flex.align-start
        v-icon(left color="black" :size="24" @click="$router.push('/admin/restaurant/pos-setup')") mdi-arrow-left
        div
          div.h6.primary--text {{ $t('section_counter_pos.title') }}
          div.c1.basic600--text {{ $t('section_counter_pos.text') }}
      counter-payment-list.mt-6.mx-2(:company="company")

</template>

<script>
import { mapActions } from 'vuex'

import CounterPaymentList from '@/components/restaurant/CounterPaymentList.vue'

export default {
  name: 'PaymentSettings',
  components: { CounterPaymentList },
  props: ['company'],
  data () {
    return {
      expansionPanels: undefined,
      addressIsEnabled: false,
      codIsEnabled: false,
      installmentEnabled: false,
      shippingMethod: null,
      allowedPaymentMethods: {
        paymentGateway: true,
        manual: true,
        cod: true,
        installment: true
      },
    }
  },
  mounted () {
    this.fetchInvoiceSettings()
    this.handleReturnFromStripeOnboarding()
    this.handleClickFromYezzaPayNoticeBanner()
  },
  methods: {
    ...mapActions(['showMessage']),
    handleActivateInstallment (val) {
      this.installmentEnabled = val
      this.updateInvoiceSettings()
    },
    fetchInvoiceSettings() {
      this.$axios.get(`/invoice_settings/?company=${this.company.id}`)
        .then((response) => {
          if (response.data.results.length != 0) {
            this.invoiceSettings = response.data.results[0]
            this.addressIsEnabled = this.invoiceSettings.address_enabled
            if (this.invoiceSettings.extra_settings) {
              this.codIsEnabled = this.invoiceSettings.extra_settings.cod_enabled
              this.installmentEnabled = this.invoiceSettings.extra_settings.installment_enabled || false

              this.shippingMethod = this.invoiceSettings.extra_settings.shipping_method

            }
          }
        }).catch(() => {})
    },
    updateInvoiceSettings () {
      const params = {
        company: this.company.id,
        address_enabled: this.addressIsEnabled,
        extra_settings: {
          cod_enabled: this.codIsEnabled,
          shipping_method: this.shippingMethod,
          installment_enabled: this.installmentEnabled,
        }
      }
      if (this.invoiceSettings) {
        this.axios.put(`/invoice_settings/${this.invoiceSettings.id}/`, params)
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
        return
      }
      this.axios.post(`/invoice_settings/`, params)
        .then((resp) => {
            this.invoiceSettings = resp.data
          })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    handleReturnFromStripeOnboarding () {
      if (this.$route.query.from_stripe_onboard) {
        this.expansionPanels = 0
        this.fetchingYezzapaySetting = true
        let textSuccess = 'Yezza Pay was successfully activated'
        let textFail = 'Yezza Pay activation was unsuccessful. Please try again.'
        if (this.$route.query.existing_stripe_migration) {
          textSuccess = 'Yezza Pay (Stripe) was successfully activated'
          textFail = 'Yezza Pay (Stripe) activation was unsuccessful. Please try again.'
        }
        setTimeout(() => {
          this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
            if (response.data.results.length > 0 && response.data.results[0].active_fpx_provider === 'stripe') {
              this.showMessage(['success', textSuccess])
            } else {
              this.showMessage(['error', textFail])
            }
          })
          .catch(() => {
            this.showMessage(['error', textFail])
          })
        }, 3000)
      }
    },
    handleClickFromYezzaPayNoticeBanner () {
      this.$watch('$store.state.ui.yezzapayMigrateModal', (val) => {
        if (val) {
          this.expansionPanels = 0
        }
      })
      this.$watch('$store.state.ui.securepayMigrateModal', (val) => {
        if (val) {
          this.expansionPanels = 0
        }
      })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "section_counter_pos": {
      "title": "Counter POS",
      "text": "Counter POS payment methods "
    },
    "section_online_store": {
      "title": "Online Store",
      "text": "Online store payment methods "
    },
    "section_table_ordering": {
      "title": "Table Ordering",
      "text": "Table ordering payment methods "
    }
  },
  "id": {
    "section_counter_pos": {
      "title": "Counter POS",
      "text": "Counter POS payment methods "
    },
    "section_online_store": {
      "title": "Online Store",
      "text": "Online store payment methods "
    },
    "section_table_ordering": {
      "title": "Table Ordering",
      "text": "Table ordering payment methods "
    }
  }
}
</i18n>
